import { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { useAuth } from '../context/auth';
import { USER_FREE_TRIAL_DAYS } from '../config';
// import { useSubscriptionId } from './stripe';

const useTrialDaysLeft = () => {
  // const getSubscription = useSubscriptionId();
  const { user, isPlanExists } = useAuth()
  const [trialDaysLeft, setTrialDaysLeft] = useState<number>(0);

  // const subscriptionId = user?.subscriptionId;

  useEffect(() => {
    const paymentSetupRequired = Boolean(user?.paymentSetupRequired);

    if (paymentSetupRequired) {
      // if (subscriptionId) {
      //   getSubscription.fetch(undefined, subscriptionId).then((response) => {
      //     if (!response?.data) return;
      //
      //     const { current_period_start, plan } = response.data;
      //
      //     const trialEndDate = moment.unix(current_period_start).add(plan?.trial_period_days, 'days');
      //     const daysLeft = trialEndDate.startOf('day').diff(moment().startOf('day'), 'days');
      //
      //     setTrialDaysLeft(daysLeft);
      //   });
      // } else {
      //   setTrialDaysLeft(0);
      // }

      setTrialDaysLeft(0);

      return;
    }

    if (!user?.createdAt) {
      setTrialDaysLeft(0);

      return;
    }

    if (isPlanExists) {
      setTrialDaysLeft(0);

      return;
    }

    const accountCreationDate = moment(user.createdAt).local().startOf('day');
    const trialEndDate = accountCreationDate.clone().add(USER_FREE_TRIAL_DAYS, 'days');
    const today = moment().local().startOf('day');
    const daysLeft = trialEndDate.diff(today, 'days');

    setTrialDaysLeft(daysLeft > 0 ? daysLeft : 0);
  }, [user, isPlanExists]);

  return trialDaysLeft;
}

export default useTrialDaysLeft;
